import { render, staticRenderFns } from "./AyudaVideoPlayer.vue?vue&type=template&id=5d45ad92&"
import script from "./AyudaVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./AyudaVideoPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports